import { createFeature, createReducer, on } from '@ngrx/store';
import { DashboardActions } from './dashboard.actions';
import { DashboardStateModel } from './models/dashboard.model';

export interface DashboardState {
  data: DashboardStateModel | null;
  loading: boolean;
}

export const initialState: DashboardState = {
  data: null,
  loading: false,
};

const reducer = createReducer(
  initialState,
  on(DashboardActions.loadRequested, (state) => ({ ...state, loading: true })),
  on(DashboardActions.loadSucceeded, (state, { data }) => ({ data: { ...data }, loading: false })),
  on(DashboardActions.loadFailed, (state) => ({ ...state, loading: false })),
  on(DashboardActions.clear, () => initialState),
);

export const dashboardFeature = createFeature({
  name: 'dashboard',
  reducer,
});
